import PropTypes from "prop-types";
import styled from "styled-components";
import { AlertTriangle } from "lucide-react";
import { Modal } from "components/Modal";
import { Button } from "components/Button";
import { COLOR_CLAY, COLOR_DARK_GREY, COLOR_YELLOW } from "style/v2/theme";

const ModalContainer = styled.div`
  padding: 28px;
  width: 100%;
  max-width: 420px;
  background: ${({ theme }) => theme.global.bg.primary};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.global.fonts.aeonik};
`;

const IconBadge = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLOR_YELLOW}1a;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${COLOR_CLAY};
  margin: 0 0 8px 0;
  text-align: left;
`;

const Body = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${COLOR_DARK_GREY};
  margin: 0 0 12px 0;
  width: 100%;
  text-align: left;
`;

const Reassurance = styled.p`
  width: 100%;
  padding: 10px 12px;
  margin: 0 0 24px 0;
  border-left: 2px solid ${COLOR_YELLOW};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${COLOR_DARK_GREY};
  text-align: left;
  box-sizing: border-box;
`;

const Actions = styled.div`
  width: 100%;
`;

const UnsupportedBankModal = ({ visible, onHide }) => {
  return (
    <Modal
      show={visible}
      onHide={onHide}
      size="auto"
      className="unsupported-bank-modal"
      showClose={true}
      centered={true}
    >
      <ModalContainer>
        <IconBadge>
          <AlertTriangle size={20} color={COLOR_YELLOW} />
        </IconBadge>

        <Title>This bank isn&apos;t supported</Title>

        <Body>
          Robinhood accounts can&apos;t be used to fund your Surmount account.
        </Body>

        <Reassurance>
          The account you selected was not saved and nothing has been connected.
        </Reassurance>

        <Actions>
          <Button variant="primary" width="100%" onClick={onHide}>
            Got it
          </Button>
        </Actions>
      </ModalContainer>
    </Modal>
  );
};

UnsupportedBankModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default UnsupportedBankModal;
